import { render, staticRenderFns } from "./PromoHeader.vue?vue&type=template&id=ddcd017a&scoped=true&"
import script from "./PromoHeader.vue?vue&type=script&lang=js&"
export * from "./PromoHeader.vue?vue&type=script&lang=js&"
import style0 from "./PromoHeader.vue?vue&type=style&index=0&id=ddcd017a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd017a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VContainer,VForm,VRow,VTextField})
